/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, Aug 8, 2018
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var Promise = require("promise");
var Set = require("es6-set");

module.exports = Model({
	name: "groupinfo",
	_groups: null,
	init: init,
	triggers: triggers,
	add: add,
	listen_groups: listen_groups,
	fetch_group_data: fetch_group_data,
});

function init() {
	this._groups = new Set();
	this.push(null);
}

function triggers() {
	return {
		"add": add,
	};
}

function add(groups) {
	if (!(groups[0])) return;
	var currentGroups = this._groups;

	if (groups.length) {
		groups.forEach(currentGroups.add.bind(currentGroups));
		this.listen_groups(groups);
		return this.fetch_group_data(groups);
	}
}

function listen_groups(groups) {
	groups.map(listen_group.bind(this));
}

function listen_group(group) {
	var self = this;
	var tracker = this.tracker;
	tracker.on("mqtt:orggroup/" + group + "/updated", handle_group_updated);

	function handle_group_updated() {
		self.fetch_group_data(group);
	}
}

function fetch_group_data(groups) {
	this.emit("save:trigger:start");
	return Promise.all(groups.map(function (group) {
		if (!group.length) return [];
		return this.api.org.group.data_public(group);
	}, this))
		.then(flatten)
		.then(make_update_map)
		.then(this.extend.bind(this))
		.catch(console.error.bind(console))
		.then(finish_save.bind(this));
}

function flatten(list) {
	return list.reduce(function (a, b) { return a.concat(b); }, []);
}

function make_update_map(data) {
	return data.reduce(function (result, user) {
		result[user._id] = user;
		return result;
	}, {});
}

function finish_save() {
	this.emit("save:trigger:finish");
}